import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import CarouselArrow from 'Components/Carousel/CarouselArrow';
import FanFavouriteCard from 'Components/Cards/FanFavouriteCard';
import SkeletonFanFavouriteCard from 'Components/Utility/Skeleton/SkeletonFanFavouriteCard';
import CarouselPaging from 'Components/Carousel/CarouselPaging';

const FanFavouritesCarousel = ({ hitData }) => {
  const settings = {
    infinite: false,
    prevArrow: <CarouselArrow ariaLabel="Previous" arrowDirection="left" containerClassName="arrow-btn-container" />,
    nextArrow: <CarouselArrow ariaLabel="Next" arrowDirection="right" containerClassName="arrow-btn-container" />,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    accessibility: true,
    customPaging: i => (
      <CarouselPaging
        slideIndex={i}
        slideLength={Array.isArray(hitData) ? hitData.length : 0}
        slidesToShow={1}
      />
    ),
    lazyLoad: false, // So google can read all reviews on page load
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '30px',
          slidesToScroll: 1,
          slidesToShow: 1,
          swipeToSlide: true,
        },
      },
    ],
  };

  const sliderRef = useRef();

  if (!hitData) return false;

  if (Array.isArray(hitData) && hitData.length === 0) {
    return (
      <div>
        <Slider ref={sliderRef} {...settings} className="product-slider">

          {[...Array(12).keys()].map(fakeHit =>
            <SkeletonFanFavouriteCard
              key={Math.random() + fakeHit}
            />,
          )}
        </Slider>
      </div>
    );
  }

  return (
    <Slider ref={sliderRef} {...settings} className="product-slider">
      {hitData.map(hit =>
        <FanFavouriteCard
          key={hit.product_id + Math.random()}
          hit={hit}
        />,
      )}
    </Slider>
  );
};

FanFavouritesCarousel.propTypes = {
  hitData: PropTypes.arrayOf(PropTypes.shape({})),
};

FanFavouritesCarousel.defaultProps = {
  hitData: [],
};

export default FanFavouritesCarousel;
